import { render, staticRenderFns } from "./ApprovisionnementsUser.vue?vue&type=template&id=080962de&"
import script from "./ApprovisionnementsUser.vue?vue&type=script&lang=js&"
export * from "./ApprovisionnementsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports